/**
 * Vuely Global Components
 */
// section tooltip
import GridPagination from './components/GridPagination.vue'
const GlobalComponents = {
   install(Vue) {
      Vue.component('GridPagination', GridPagination); 
   }
}

export default GlobalComponents



// WEBPACK FOOTER //
// ./src/globalComponents.js